module.exports = __webpack_public_path__ + "static/media/cms1.6d81f9d5.png";